<div class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
  <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
    <div class="gap-1">
      <div class="text-sm font-semibold uppercase text-700">Oooops!</div>
      <div class="text-sm">{{message}}</div>
      <div class="text-sm text-700 font-light">{{hint}}</div>
    </div>
    <div *ngIf="withImage"><img alt="image" class="h-12rem opacity-70" src="./assets/images/empty2.png"></div>
  </div>
</div>
